import { SVGICON } from "../../constant/theme";

export const MenuList = [
  //Content
  {
    title: "TalenTrail",
    classsChange: "menu-title",
  },
  //Dashboard
  {
    title: "Dashboard",
    iconStyle: SVGICON.Home,
    to: "/dashboard",
  },
  {
    title: "Candidates",
    classsChange: "mm-collapse",
    iconStyle: SVGICON.Apps,
    content: [
      {
        title: "Candidate List",
        to: "/candidates",
      },
      {
        title: "Search Candidate",
        to: "/search-candidate",
      },
    ],
  },
  {
    title: "Companies",
    classsChange: "mm-collapse",
    iconStyle: SVGICON.ProjectIcon,
    content: [
      {
        title: "Company List",
        to: "/companies",
      },
      {
        title: "Search Companies",
        to: "/search-company",
      },
    ],
  },
  {
    title: "Requirement",
    classsChange: "mm-collapse",
    iconStyle: SVGICON.Forms,
    content: [
      {
        title: "Requirement Plan List",
        to: "/requirement-plans",
      },
    ],
  },
  {
    title: "Reports",
    iconStyle: SVGICON.Charts,
    to: "/reports",
  },
  {
    title: "Settings",
    onlyAdmin: true,
    classsChange: "mm-collapse",
    iconStyle: SVGICON.Settings,
    content: [
      {
        title: "List Of Values",
        to: "/lov",
      },
      {
        title: "Templates",
        to: "/templates",
      },
    ],
  }
];
